module.exports = __webpack_public_path__ + "img/ingram-micro-logo.33f5026d.png";